/*
 * Copyright (C) 2021 Quartet Health, Inc - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 */

export const scrollToTop = () => {
  window.scrollTo &&
    window.scrollTo({
      top: 0,
      left: 0
    });
};

export const smoothScrollToTop = () => {
  window.scrollTo &&
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: 'smooth'
    });
};
